import http from "./http"

export const CheckInScheduleService = {
  fetchFor(participantIds) {
    const params = {}
    params["client_participant_ids[]"] = participantIds
    return http.get("/check_in_schedules", { params }).then((res) => res.data)
  },

  update(participantId, rule) {
    return http.put(`/check_in_schedules/${participantId}`, rule)
  },
}

export default CheckInScheduleService
